<div fxLayout="column" fxLayoutAlign="center start">
  <div *ngIf="getFilterOptions(node.type) as options" fxFill fxLayout="row" fxLayoutAlign="space-between center">
    <app-mat-simple-select
      fxFlex="50"
      label="Select Filter"
      [disabled]="!options.length"
      [selectItems]="options"
      [(ngModel)]="filterSelect"
    ></app-mat-simple-select>

    <button mat-raised-button [disabled]="!filterSelect" (click)="onAddFilter()">Add Filter</button>
  </div>

  <div
    *ngFor="let filterGroup of eventFlowFilterGroups; let i = index"
    fxFill
    fxLayout="row"
    fxLayoutAlign="space-between"
  >
    <div fxFlex fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
      <app-mat-multiselect
        fxFlex="70"
        [label]="UNIQUE_FILTER_LABELS[filterGroup.get('key')?.value] + ' *'"
        [allowCustomValue]="true"
        [required]="true"
        [autoCompleteValues]="getSelectValues(filterGroup.get('key')?.value)"
        [formControl]="$any(filterGroup.get('values'))"
      ></app-mat-multiselect>

      <app-mat-simple-select
        fxFlex="30"
        label="Mode"
        [selectItems]="modeOptions"
        [formControl]="$any(filterGroup.get('mode'))"
      ></app-mat-simple-select>
    </div>

    <button mat-icon-button style="margin-top: 20px" (click)="onRemoveFilter(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
